const changeTravleType = {
  state: {
    changeTravleType: 0,
    area: '',
    areaChoose: 0
  },
  mutations: {
    SET_CHANGETRAVLE (state, changeTravleType) {
      state.changeTravleType = changeTravleType
    },
    SET_AREA (state, area) {
      state.area = area
    },
    SET_AREACHOOSE (state, areaChoose) {
      state.areaChoose = areaChoose
    }
  }
}

export default changeTravleType



// WEBPACK FOOTER //
// ./src/store/modules/changeTravleType.js